import script from "./Anonymization.vue?vue&type=script&setup=true&lang=js"
export * from "./Anonymization.vue?vue&type=script&setup=true&lang=js"

import "./Anonymization.vue?vue&type=style&index=0&id=4267913e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4267913e"]])

export default __exports__